import React from 'react'
import './style.scss'

const HomeMainTitle = (props) => {
    return (
        <div className='HomeMainTitle'>
            <h2>{props.children}</h2>
            <div className='lines'>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>
        </div>
    )
}

export default HomeMainTitle
